import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postCustomerDiscounts = async ({ customerId, discounts }: JsonDataItem) => {
  const { data } = await baseQuery('customer-discount', {
    type: 'POST',
    body: {
      customer_id: customerId,
      discounts,
    },
  });

  return data;
};
